import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconNorthStarComponent } from "./med-icon-north-star.component";

@NgModule({
  declarations: [
    MedIconNorthStarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconNorthStarComponent,
  ],
})
export class MedIconNorthStarModule { }
